// extracted by mini-css-extract-plugin
export default {"content":"SocietyAdminLogo_content__rPuVj","realContent":"SocietyAdminLogo_realContent__oe+En","societyImage":"SocietyAdminLogo_societyImage__u29ZI"};